<div class="container" [ngClass]="{'checkbox':type=='checkbox', 'text':type=='text', 'error': error}">
  <label>
    <div class="checkbox-container" *ngIf="type=='checkbox'">
      <ng-content #input select="input[type='checkbox']"></ng-content>
      <span class="checkbox-spoof"></span>
    </div>

    <span class="label">
      <ng-content></ng-content>
    </span>
    
    <div class="input-container">
      <ng-content select="input"></ng-content>
      <ng-content select="[input]"></ng-content>
      <ng-content select="select"></ng-content>
      <ng-content select="textarea"></ng-content>
    </div>
    <div class="info-container" *ngIf="type==='info'">
      <ng-content select="[info]"></ng-content>
    </div>
  </label>

  <ng-content select="[app-input-error]"></ng-content>  
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/input/input.component.html